/* eslint-disable import/prefer-default-export */

import { LOAD_BULK_EDIT_ITEMS } from '../constants/bulkEditItemsConstants';

export const loadBulkItemsList = bulkEditItemsSettings => ({
  type                  : LOAD_BULK_EDIT_ITEMS,
  bulkEditItemsSettings,
});
